module.exports = __webpack_public_path__ + "media/images/icons/ic-settings-c3602b6466edad141640362e45b7b9cb.svg";